export const SET_MODAL_SUCCES_ACTIVE = 'SET_MODAL_SUCCES_ACTIVE';
export const RESET_MODAL_SUCCES_ACTIVEN = 'RESET_MODAL_SUCCES_ACTIVEN';

export const setModalSuccessActive = (payload) => dispatch => {
    dispatch({
        type: SET_MODAL_SUCCES_ACTIVE,
        payload
    });
};

export const resetModalSuccessActive = () => dispatch => {
    dispatch({
        type: RESET_MODAL_SUCCES_ACTIVEN
    });
};


// WEBPACK FOOTER //
// ./src/actions/modalsuccesactive.js